import { render, staticRenderFns } from "./EmailSignature.vue?vue&type=template&id=4cc79cd3&scoped=true&"
import script from "./EmailSignature.vue?vue&type=script&lang=js&"
export * from "./EmailSignature.vue?vue&type=script&lang=js&"
import style0 from "./EmailSignature.vue?vue&type=style&index=0&id=4cc79cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc79cd3",
  null
  
)

export default component.exports